export enum MissionType {
  None = 0,
  GameFinish = 1,
  GameWin = 2,
  LeaguePointEarn = 3,
  GameEarn = 4,
  GameWinningStreak = 5,
  SlotFinish = 6,
  SlotWin = 7,
  SlotChipSpent = 8,
  SlotChipEarn = 9,
}
